import { render, staticRenderFns } from "./integralOrderDetail.vue?vue&type=template&id=2ee60669&scoped=true&"
import script from "./integralOrderDetail.vue?vue&type=script&lang=js&"
export * from "./integralOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee60669",
  null
  
)

export default component.exports